// extracted by mini-css-extract-plugin
export default {"Box":"SubIssuesList-module__Box--swtyj","ButtonGroup":"SubIssuesList-module__ButtonGroup--j4X5w"};